import * as React from 'react';
import { useFiltersContext } from '../../contexts/filters';
const { __, sprintf } = wp.i18n;

const Select = ({ taxonomy }) => {
	let options = taxonomy.terms.map((term) => {
		// decode htmlentities.
		const label = document.createElement('textarea');
		label.innerHTML = term.name;

		return {
			label: label.value,
			value: '' + term.term_id,
		};
	});

	options = [
		{
			label: sprintf(
				/* translators: %s is the plural post type name */
				__('All %s', 'wex'),
				taxonomy.labels.name.toLowerCase()
			),
			value: '',
		},
		...options,
	];

	const { selectedTax, selectTaxTerm } = useFiltersContext();
	const [value, setValue] = React.useState(options[0]);

	const prevValue = React.useRef(options[0].value);

	// When filters are reset, set our value back to the first option.
	React.useEffect(() => {
		if (!Object.values(selectedTax).length) {
			setValue(options[0]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTax]);

	const setNotEmpty = (element) => {
		const field = element.closest('.phoenix-select');
		if (null === field) {
			return;
		}

		if (element.value.length) {
			field.classList.add('not-empty');
		} else {
			field.classList.remove('not-empty');
		}
	};

	const handleOnChange = (event) => {
		const optionValue = event.target.value;
		if (prevValue.current !== optionValue) {
			setValue(optionValue);
			selectTaxTerm(taxonomy.name, optionValue);

			prevValue.current = optionValue;
		}

		setNotEmpty(event.target);
	};

	const selectClass = `phoenix-select ${value.length ? 'not-empty' : ''}`;

	return (
		<div
			className={selectClass}
			role="region"
			aria-label={`filter by ${taxonomy.labels.singular}`}
		>
			<label htmlFor={taxonomy.name}>
				<span className="sr-only">Filter by </span>
				{taxonomy.labels.singular}
			</label>
			<div className="phoenix-select__wrapper">
				<select
					onChange={handleOnChange}
					value={value}
					key={taxonomy.name}
					id={taxonomy.name}
				>
					<option value=""></option>
					{options.map((option, key) => (
						<option value={option.value} key={key}>
							{option.label}
						</option>
					))}
				</select>
			</div>
		</div>
	);
};

Select.displayName = 'Select';

export default Select;
